"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    color: prop_types_1.default.string,
    font: prop_types_1.default.string,
    fontFamily: prop_types_1.default.string,
    fontSize: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    fontStyle: prop_types_1.default.string,
    fontVariant: prop_types_1.default.string,
    fontWeight: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    letterSpacing: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    lineHeight: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    textAlign: prop_types_1.default.string,
    textDecoration: prop_types_1.default.string,
    textOverflow: prop_types_1.default.string,
    textShadow: prop_types_1.default.string,
    textTransform: prop_types_1.default.string,
    whiteSpace: prop_types_1.default.string,
    wordBreak: prop_types_1.default.string,
    wordWrap: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const textAlign = {
    className: 'txt-algn',
    safeValue: true,
    cssName: 'text-align',
    jsName: 'textAlign'
};
const textDecoration = {
    className: 'txt-deco',
    cssName: 'text-decoration',
    jsName: 'textDecoration'
};
const textTransform = {
    className: 'txt-trns',
    cssName: 'text-transform',
    jsName: 'textTransform',
    safeValue: true
};
const textShadow = {
    className: 'txt-shdw',
    cssName: 'text-shadow',
    jsName: 'textShadow',
    complexValue: true
};
const textOverflow = {
    className: 'txt-ovrf',
    cssName: 'text-overflow',
    jsName: 'textOverflow',
    safeValue: true
};
const color = {
    className: 'color',
    cssName: 'color',
    jsName: 'color'
};
const font = {
    className: 'fnt',
    cssName: 'font',
    jsName: 'font',
    complexValue: true
};
const fontFamily = {
    className: 'fnt-fam',
    cssName: 'font-family',
    jsName: 'fontFamily',
    complexValue: true
};
const fontSize = {
    className: 'fnt-sze',
    cssName: 'font-size',
    jsName: 'fontSize'
};
const fontStyle = {
    className: 'fnt-stl',
    cssName: 'font-style',
    jsName: 'fontStyle',
    safeValue: true
};
const fontVariant = {
    className: 'f-vari',
    cssName: 'font-variant',
    jsName: 'fontVariant'
};
const fontWeight = {
    className: 'f-wght',
    cssName: 'font-weight',
    jsName: 'fontWeight',
    safeValue: true,
    defaultUnit: ''
};
const lineHeight = {
    className: 'ln-ht',
    cssName: 'line-height',
    jsName: 'lineHeight',
    defaultUnit: ''
};
const wordBreak = {
    className: 'wrd-brk',
    cssName: 'word-break',
    jsName: 'wordBreak',
    safeValue: true
};
const wordWrap = {
    className: 'wrd-wrp',
    cssName: 'word-wrap',
    jsName: 'wordWrap',
    safeValue: true
};
const whiteSpace = {
    className: 'wht-spc',
    cssName: 'white-space',
    jsName: 'whiteSpace',
    safeValue: true
};
const letterSpacing = {
    className: 'ltr-spc',
    cssName: 'letter-spacing',
    jsName: 'letterSpacing'
};
exports.propEnhancers = {
    color: (value) => get_css_1.default(color, value),
    font: (value) => get_css_1.default(font, value),
    fontFamily: (value) => get_css_1.default(fontFamily, value),
    fontSize: (value) => get_css_1.default(fontSize, value),
    fontStyle: (value) => get_css_1.default(fontStyle, value),
    fontVariant: (value) => get_css_1.default(fontVariant, value),
    fontWeight: (value) => get_css_1.default(fontWeight, value),
    letterSpacing: (value) => get_css_1.default(letterSpacing, value),
    lineHeight: (value) => get_css_1.default(lineHeight, value),
    textAlign: (value) => get_css_1.default(textAlign, value),
    textDecoration: (value) => get_css_1.default(textDecoration, value),
    textOverflow: (value) => get_css_1.default(textOverflow, value),
    textShadow: (value) => get_css_1.default(textShadow, value),
    textTransform: (value) => get_css_1.default(textTransform, value),
    whiteSpace: (value) => get_css_1.default(whiteSpace, value),
    wordBreak: (value) => get_css_1.default(wordBreak, value),
    wordWrap: (value) => get_css_1.default(wordWrap, value)
};
//# sourceMappingURL=data:application/json;base64,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